// extracted by mini-css-extract-plugin
export default {"articleHeroWrapper":"ArticleHero_articleHeroWrapper__u5Ln0","compact":"ArticleHero_compact__DFk6d"};